/* global SeriesFiltersEnabled */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroller';
import _ from 'lodash';
import BreadcrumbsComponent, { breadcrumbsShowsParser } from 'components/Breadcrumbs';
import Grid from 'components/Grid';
import ShowsTiles from 'screens/Shows/components/ShowsTiles';
import Loader from 'components/Loader';
import { setFirstPage } from 'components/Panel/PanelActions';
import Panel from 'components/Panel';
import { isStaticRender, getErrorComponent } from 'helpers/ContentHelper';
import { setHelmetTags } from 'helpers/HelmetHelper';
import { noop } from 'helpers/GlobalHelper';
import { SHOW_THUMBNAIL_IMAGE, renderImage } from 'helpers/ImageHelper';
import {
  handleTealiumButtonAction,
  PageNames,
  trackPageReferrerAnalytics,
} from '@foxcorp/delta-web-analytics';
import { onFilterClick, OVERLAY_SHOWS_FILTER } from 'helpers/FilterHelper';
import { cleanString, helperGetShowsUrl } from 'helpers/RouteHelper';
import { listProcessorWithAnimation, listItemProcessor } from 'helpers/VideoProcessorHelper';
import { renderGrid } from 'helpers/GridHelper';
import {
  fetchNextPage,
  fetchPanelPaginationLoop,
  paginationLoader,
  toggleFetching,
  resetPagination,
  getPaginationData,
  getPaginationNextUrl,
  renderHelper,
} from 'helpers/PaginationHelper';
import { helperGetApiHeaders, helperConvertApiRoute } from 'helpers/ApiHelper';
import {
  SITE_PLATFORM_WEB_LARGE,
  SITE_PLATFORM_WEB,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_MOBILE,
} from 'helpers/BreakpointHelper';
import { fetchShows, resetStore, setSuggestedTab } from './ShowsActions';
import style from './Shows.css';

const searchTileTheme = 'components/TileV2/Styles/SearchTile.module.scss';

const BREAKPOINTS = {
  [SITE_PLATFORM_WEB_LARGE]: {
    renderList: false,
  },
  [SITE_PLATFORM_WEB]: {
    renderList: false,
  },
  [SITE_PLATFORM_TABLET]: {
    renderList: false,
  },
  [SITE_PLATFORM_MOBILE]: {
    renderList: true,
  },
};

class Shows extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: true,
      selectedFilter: null,
      suggestedLoaded: false,
      initialDataLoaded: false,
    };
    this.onFilterClick = onFilterClick.bind(this, props.fetchShows);
    this.paginationLoader = paginationLoader.bind(this);
    this.getPaginationData = getPaginationData.bind(this);
    this.setSelectedFilter = this.setSelectedFilter.bind(this);
    this.openDropdown = this.openDropdown.bind(this);
    this.closeDropdown = this.closeDropdown.bind(this);
    this.renderLoader = this.renderLoader.bind(this);
    this.renderFilteredPanel = this.renderFilteredPanel.bind(this);
    this.renderHelper = renderHelper.bind(this);
    this.trackPageReferrerAnalytics = trackPageReferrerAnalytics.bind(this);
  }

  componentDidMount() {
    const {
      accessToken,
      deviceId,
      fetchShows,
      filteredPanel,
      getUseUtagGlobal,
      pageViewEvent,
      panels,
      params: { collectionId, filterId },
      route: { isRetiredShowsPage },
      setListPage,
      setSuggestedTab,
    } = this.props;
    if (panels || filteredPanel) this.setState({ showLoader: false });
    pageViewEvent({ pageName: PageNames.SHOWS, useUtagGlobal: getUseUtagGlobal() });
    if (collectionId || filterId) {
      setSuggestedTab({ suggestedNetwork: collectionId, suggestedFilter: filterId });
    }
    if (!isStaticRender()) fetchShows({ accessToken, deviceId, isRetiredShowsPage });
    if (setListPage) setListPage(true);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      accessToken,
      deviceId,
      panels,
      tabs: nextTabs,
      filters: nextFilters,
      panels: nextPanels,
      params: { collectionId: nextCollectionId, filterId: nextFilter },
      currentTab: nextTab,
    } = nextProps;
    const {
      accessToken: prevAccessToken,
      suggestedNetwork,
      suggestedFilter,
      fetchShows,
      filteredPanel,
      setListPage,
      params: { collectionId, filterId: filter },
      currentTab,
      panels: currentPanels,
      route: { isRetiredShowsPage },
    } = this.props;
    let newState = {};
    const { selectedFilter, suggestedLoaded, initialDataLoaded } = this.state;
    const firstPanelsLoaded = !initialDataLoaded && !currentPanels && nextPanels;
    const collectionIdChanged = collectionId && collectionId !== nextCollectionId;
    const nextFilterName = nextFilter && _.toLower(decodeURIComponent(nextFilter));
    const filterChanged = filter !== nextFilter;
    const tabChanged = currentTab !== nextTab;
    const nextFilterMatchesSelectedFilter = nextFilterName === _.toLower(selectedFilter);
    const updateFilter = filterChanged && !tabChanged && !nextFilterMatchesSelectedFilter;
    const accessTokenChanged = prevAccessToken !== accessToken;

    if (setListPage) setListPage(true);
    if (panels || filteredPanel) newState.showLoader = false;

    if (firstPanelsLoaded) {
      newState.initialDataLoaded = true;
      this.setState(newState);
      newState = {};
      const screenPanels = _.get(nextPanels, 'member');
      const decodedCollectionId = _.toLower(decodeURIComponent(nextCollectionId));
      const collectionIdPanelIndex = _.findIndex(screenPanels, o => {
        const { id, headline } = o;
        const isIdMatch = id === nextCollectionId;
        const isHeadlineMatch = cleanString(headline) === decodedCollectionId;
        return isIdMatch || isHeadlineMatch;
      });
      const collectionIdPanel = screenPanels[collectionIdPanelIndex];
      const defaultPanel = _.get(screenPanels, '0');
      const panel = collectionIdPanel || defaultPanel;
      const panelId = _.get(panel, 'id');
      const collection = _.get(panel, 'items');
      const collectionFilters = _.get(panel, 'customViews');
      const preSelectedFilter = _.find(
        collectionFilters,
        p => _.toLower(_.get(p, 'name')) === nextFilterName,
      );
      const filterName = _.get(preSelectedFilter, 'name');
      const filterUrl = _.get(preSelectedFilter, 'url');
      const loadPreselectedFilter = filterName && filterUrl;

      if (nextCollectionId) {
        if (loadPreselectedFilter) return this.onFilterClick({ name: filterName, url: filterUrl });
        return fetchShows({ accessToken, deviceId, tabId: panelId, filteredPanel: collection });
      }
      if (loadPreselectedFilter) return this.onFilterClick({ name: filterName, url: filterUrl });
    }

    if (collectionIdChanged) {
      const useDefaultCollectionId = !nextCollectionId;
      const { tabs } = this.props;
      newState.selectedFilter = null;
      const tab = useDefaultCollectionId
        ? tabs[0]
        : _.find(tabs, o => {
            const { headline } = o;
            return cleanString(headline) === decodeURIComponent(nextCollectionId);
          });
      if (tab) {
        const { id: tabId, items } = tab;
        fetchShows({ accessToken, deviceId, filteredPanel: items, tabId });
      }
    } else if (tabChanged) {
      if (!nextFilterName) newState.selectedFilter = null;
      const tab = _.find(nextTabs, t => _.get(t, 'id') === nextTab);
      const tabFilters = _.get(tab, 'customViews');
      const newFilter =
        _.find(tabFilters, f => _.toLower(_.get(f, 'name')) === nextFilterName) || {};
      const { name, url } = newFilter;
      if (name && url) this.onFilterClick({ name, url });
    } else if (updateFilter) {
      const tabFilters = _.get(
        _.find(nextTabs, t => _.get(t, 'id') === currentTab),
        'customViews',
      );
      const defaultFilter = tabFilters[0];
      const newFilter =
        _.find(tabFilters, f => _.toLower(_.get(f, 'name')) === nextFilterName) || defaultFilter;
      const { name, url } = newFilter;
      const ignoreUpdatingUrl = newFilter === defaultFilter;
      if (name && url) this.onFilterClick({ name, url, ignoreUpdatingUrl });
    }

    // handle suggestedFilter
    if (
      suggestedLoaded === false &&
      ((nextTabs && nextFilters && suggestedFilter) || accessTokenChanged)
    ) {
      const newFilter = _.find(nextFilters, categoryFilter => {
        const filterName = _.get(categoryFilter, 'name', '').toLowerCase();
        return filterName === suggestedFilter;
      });
      const newFilterUrl = _.get(newFilter, 'url');
      if (newFilterUrl) {
        const suggestedData = { url: newFilterUrl };
        fetchShows({ accessToken, deviceId, ...suggestedData });
        newState = Object.assign(newState, {
          suggestedLoaded: true,
          selectedFilter: suggestedFilter,
        });
        return this.setState(newState);
      }
    }

    // handle suggestedNetwork
    if (
      suggestedLoaded === false &&
      ((nextTabs && suggestedNetwork && !filteredPanel) || accessTokenChanged)
    ) {
      const suggestedTab = _.find(nextTabs, tab => {
        const headline = _.get(tab, 'headline', '').toLowerCase();
        return headline === suggestedNetwork;
      });
      const suggestedData = {
        tabId: _.get(suggestedTab, 'id'),
        filteredPanel: _.get(suggestedTab, 'items'),
      };
      fetchShows({ accessToken, deviceId, ...suggestedData, isRetiredShowsPage });
      newState.suggestedLoaded = true;
      return this.setState(newState);
    }
    if (!_.isEmpty(newState)) this.setState(newState);
    return null;
  }

  componentWillUnmount() {
    const { resetStore, setListPage, setSuggestedTab } = this.props;
    resetStore();
    this.closeDropdown();
    this.trackPageReferrerAnalytics({
      name: PageNames.SHOWS,
    });
    if (setListPage) setListPage(false);
    setSuggestedTab({ suggestedNetwork: null });
  }

  getBreadcrumbsData() {
    const {
      tabs,
      currentTab,
      params,
      route: { isRetiredShowsPage },
    } = this.props;
    const { selectedFilter } = this.state;
    if (!tabs) return null;
    const selectedTabs = tabs.filter(t => t.id === currentTab);
    const selectedTab = _.get(selectedTabs, '0');
    return breadcrumbsShowsParser({ tab: selectedTab, params, selectedFilter, isRetiredShowsPage });
  }

  setSelectedFilter(value) {
    const { selectedFilter } = this.state;
    if (value === selectedFilter) return;
    this.setState({ selectedFilter: value });
  }

  closeDropdown = () => {
    const { setOverlay } = this.props;
    setOverlay(OVERLAY_SHOWS_FILTER, false);
  };

  openDropdown = () => {
    const { setOverlay } = this.props;
    setOverlay(OVERLAY_SHOWS_FILTER, true);
  };

  renderFilteredPanel() {
    const { accessToken, deviceId, panels, filteredPanel, paginatedPanels } = this.props;
    const panelToRender = filteredPanel || _.get(panels, 'member.0.items');
    if (!panelToRender) return null;
    const { '@id': id } = panelToRender;
    const panel = _.get(paginatedPanels, `${id}`);
    const paginationUrl = _.get(panel, 'paginationUrl');
    const hasMore = _.get(panel, 'hasMoreItems', false);

    const showPanelRenderer = showPanel => {
      const { breakpoint, fetching, fetchingPage } = this.props;

      if (!showPanel) return null;

      const { member } = showPanel;
      const tileIndexOffset = 0;
      const { renderList } = BREAKPOINTS[breakpoint];
      const grid = renderGrid({
        key: `filteredPanel-${id}`,
        items: member,
        listProcessor: listItemProcessor,
        gridProcessor: listProcessorWithAnimation,
        tileGridTrackButtonClick: handleTealiumButtonAction,
        gridType: 'grid-5-4-3-1',
        style,
        tileDetailToggle: false,
        tileTheme: searchTileTheme,
        tileType: 'fadeAnimated',
        renderList,
        renderImage: image =>
          renderImage({
            breakpoint,
            imageType: SHOW_THUMBNAIL_IMAGE,
            ...image,
          }),
        tileIndexOffset,
      });

      const loadMore = () => {
        if (!fetchingPage) this.panel.fetchNextPage();
      };
      const loadingIcon = fetching || fetchingPage ? <Loader /> : null;
      return (
        <InfiniteScroll pageStart={0} loadMore={loadMore} hasMore={hasMore}>
          <div className={style.scrollContainer}>
            {grid}
            {loadingIcon}
          </div>
        </InfiniteScroll>
      );
    };

    return (
      <Panel
        accessToken={accessToken}
        deviceId={deviceId}
        renderer={showPanelRenderer}
        panelData={panelToRender}
        headerGenerator={helperGetApiHeaders}
        routeGenerator={helperConvertApiRoute}
        pageType="shows"
        panelId={id}
        data-test="web-shows-content"
        hasInfiniteScroll
        hasMoreItems={hasMore}
        onRef={ref => {
          this.panel = ref;
        }}
        propsToWatch={{ paginationUrl }}
      />
    );
  }

  renderLoader() {
    const { setLoading } = this.props;
    const { showLoader } = this.state;
    if (showLoader) {
      return <Loader setLoading={setLoading} center />;
    }
    return null;
  }

  renderRetiredShows = () => {
    const { panels, breakpoint } = this.props;
    const items = _.get(panels, 'member.0.items.member');

    if (!items) return null;
    return (
      <div className={style.screen}>
        <Grid gridType="grid-5-4-3-1">
          <ShowsTiles items={items} breakpoint={breakpoint} />
        </Grid>
      </div>
    );
  };

  render() {
    const {
      seo,
      errors,
      fetchShows,
      isNavScheduleRendered,
      route: { isRetiredShowsPage },
    } = this.props;
    const { showLoader } = this.state;
    if (errors) return getErrorComponent(errors);

    const { showsPage_header: titleShows } = window.Language;
    const route = helperGetShowsUrl();
    const breadcrumbs = <BreadcrumbsComponent data={this.getBreadcrumbsData()} />;
    const useTileRefactor = false;
    const content =
      isRetiredShowsPage && useTileRefactor
        ? this.renderRetiredShows()
        : this.renderHelper({
            title: titleShows,
            overlayName: OVERLAY_SHOWS_FILTER,
            displayDropdown: SeriesFiltersEnabled,
            fetch: fetchShows,
            style,
            route,
            isNavScheduleRendered,
            isRetiredShowsPage,
            parentState: this.state,
            parentProps: this.props,
            onFilterClick: this.onFilterClick,
            setSelectedFilter: this.setSelectedFilter,
            openDropdown: this.openDropdown,
            closeDropdown: this.closeDropdown,
            renderLoader: this.renderLoader,
            renderFilteredPanel: this.renderFilteredPanel,
          });
    return (
      <div className={style.contentContainer}>
        {content}
        {setHelmetTags(seo)}
        {!showLoader ? breadcrumbs : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    panels: state.shows.panels,
    seo: state.shows.seo,
    errors: state.shows.errors,
    filteredPanel: state.shows.filteredPanel,
    nextPage: state.shows.nextPage,
    paginationItems: state.shows.paginationItems,
    fetching: state.shows.fetching,
    tabs: state.shows.tabs,
    currentTab: state.shows.currentTab,
    filters: state.shows.filters,
    suggestedNetwork: state.shows.suggestedNetwork,
    suggestedFilter: state.shows.suggestedFilter,
    fetchingPage: state.panel.fetching,
    paginatedPanels: state.panel.panels,
  };
}

Shows.fetchData = ({ store, accessToken }) =>
  store.dispatch(fetchShows({ accessToken })).then(response => {
    const panel = _.get(response, 'payload.data.panels.member[0].items', null);
    const panelId = _.get(panel, '@id');
    store.dispatch(setFirstPage(panel, panelId));
    const url = getPaginationNextUrl(response);
    const headers = helperGetApiHeaders({ pathKey: 'shows', accessToken });
    return fetchPanelPaginationLoop({ store, url, panelId, headers });
  });

Shows.defaultProps = {
  accessToken: null,
  currentTab: null,
  deviceId: null,
  errors: {},
  fetching: false,
  fetchingPage: false,
  filteredPanel: {},
  getUseUtagGlobal: noop,
  paginatedPanels: null,
  panels: {},
  route: {},
  seo: null,
  setListPage: noop,
  setLoading: null,
  suggestedFilter: null,
  suggestedNetwork: null,
  tabs: [],
};

Shows.propTypes = {
  accessToken: PropTypes.string,
  breakpoint: PropTypes.string.isRequired,
  deviceId: PropTypes.string,
  errors: PropTypes.number,
  filteredPanel: PropTypes.shape({
    itemPerPage: PropTypes.number,
    member: PropTypes.arrayOf(PropTypes.shape({})),
    totalItems: PropTypes.number,
  }),
  fetching: PropTypes.bool,
  fetchShows: PropTypes.func.isRequired,
  getUseUtagGlobal: PropTypes.func,
  isNavScheduleRendered: PropTypes.bool.isRequired,
  route: PropTypes.shape({}),
  pageViewEvent: PropTypes.func.isRequired,
  panels: PropTypes.shape({
    itemsPerPage: PropTypes.number,
    member: PropTypes.arrayOf(PropTypes.shape({})),
    totalItems: PropTypes.number,
  }),
  resetStore: PropTypes.func.isRequired,
  seo: PropTypes.shape({}),
  setListPage: PropTypes.func,
  setLoading: PropTypes.func,
  setSuggestedTab: PropTypes.func.isRequired,
  setOverlay: PropTypes.func.isRequired,
  suggestedNetwork: PropTypes.string,
  suggestedFilter: PropTypes.func,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      createDynamicCustomViews: PropTypes.bool,
      dateModified: PropTypes.string,
      dynamicCustomViewsFilter: PropTypes.arrayOf(PropTypes.string),
      headline: PropTypes.string,
      hideIfLoggedIn: PropTypes.bool,
      hideIfNotLoggedIn: PropTypes.bool,
      hideIfNotUserNetwork: PropTypes.arrayOf(PropTypes.string),
      id: PropTypes.string,
      imageTypes: PropTypes.arrayOf(PropTypes.string),
      images: PropTypes.shape({}),
      items: PropTypes.shape({}),
      name: PropTypes.string,
      panelType: PropTypes.string,
      validFor: PropTypes.number,
    }),
  ),
  currentTab: PropTypes.string,
  params: PropTypes.shape({}).isRequired,
  fetchingPage: PropTypes.bool,
  paginatedPanels: PropTypes.shape({}),
};

export default connect(mapStateToProps, {
  fetchNextPage,
  fetchShows,
  resetPagination,
  resetStore,
  setSuggestedTab,
  toggleFetching,
})(Shows);
